import { MarkerLocation } from '../../models/map.model';

export function isHealthLocation(location: MarkerLocation) {
    return location.hasOwnProperty("health");
}
